export type ColleagueQuote = {
  quote: string;
  attribution: string;
};

export const colleagueQuotes: ColleagueQuote[] = [
  {
    quote: "Omer consistently puts the long-term health of the business ahead of short-term wins.",
    attribution: "Senior Director, Legal Counsel @ Cloudflare",
  },
  {
    quote: "Omer has a clear sense for how today's product decisions will shape the company years later.",
    attribution: "Senior Director, Legal Counsel @ Cloudflare",
  },
  {
    quote: "Omer combines strategic judgment, institutional knowledge, and trust in a way that makes him highly effective.",
    attribution: "Senior Director, Legal Counsel @ Cloudflare",
  },
  {
    quote: "Omer is a strong example of doing the right thing when product decisions carry real customer and company impact.",
    attribution: "Senior Director, Legal Counsel @ Cloudflare",
  },
  {
    quote: "Omer keeps complex workstreams moving with focus, clarity, and strong leadership discipline.",
    attribution: "Strategic Partnerships Director @ Cloudflare",
  },
  {
    quote: "Omer quickly finds the heart of an obstacle and helps teams move toward a practical resolution.",
    attribution: "Strategic Partnerships Director @ Cloudflare",
  },
  {
    quote: "Omer thinks beyond feature delivery, balancing tradeoffs, long-term impact, and technical complexity.",
    attribution: "Engineering Manager @ Cloudflare",
  },
  {
    quote: "Omer maintains high quality standards without being distracted by short-term wins.",
    attribution: "Engineering Manager @ Cloudflare",
  },
  {
    quote: "Omer brings strategic awareness, strong communication, and empathy that raises the quality of the team around him.",
    attribution: "Engineering Manager @ Cloudflare",
  },
  {
    quote: "Omer is the kind of leader people want to work with again in larger leadership roles.",
    attribution: "Engineering Manager @ Cloudflare",
  },
  {
    quote: "Omer would be an exceptional asset to any organization that values technical product leadership.",
    attribution: "Engineering Manager @ Cloudflare",
  },
  {
    quote: "When Omer owns a project, teams trust that it will be handled with care and discipline.",
    attribution: "Lead Product Designer @ Cloudflare",
  },
  {
    quote: "Omer manages the full product lifecycle with attention to architecture, user experience, and launch quality.",
    attribution: "Lead Product Designer @ Cloudflare",
  },
  {
    quote: "Omer bridges product, design, and engineering so teams can make progress with shared context.",
    attribution: "Lead Product Designer @ Cloudflare",
  },
  {
    quote: "Omer turns customer feedback into clear product priorities that help teams build what customers actually need.",
    attribution: "Systems Engineer @ Cloudflare",
  },
  {
    quote: "Omer advocates for important projects and keeps momentum alive through ambiguity.",
    attribution: "Product Design Lead @ Cloudflare",
  },
  {
    quote: "Omer is unusually diligent, organized, and transparent in how he tracks product work.",
    attribution: "Product Design Lead @ Cloudflare",
  },
  {
    quote: "Omer delivers meaningful product improvements and helps teams launch successful security capabilities.",
    attribution: "Principal Supportability Program Manager @ Cloudflare",
  },
  {
    quote: "Omer has proven he can lead teams through complex product improvements and deliver strong outcomes.",
    attribution: "Principal Supportability Program Manager @ Cloudflare",
  },
  {
    quote: "Omer understands the security space deeply and keeps the customer perspective close to the work.",
    attribution: "Senior Engineering Manager @ Cloudflare",
  },
  {
    quote: "Omer shows strong potential for broader leadership scope.",
    attribution: "Senior Engineering Manager @ Cloudflare",
  },
  {
    quote: "Omer's support is instrumental in keeping important product work moving forward.",
    attribution: "Systems Engineer @ Cloudflare",
  },
  {
    quote: "Omer gives thoughtful go-to-market feedback and is excellent at workshopping strategic ideas.",
    attribution: "Strategic Partnerships Director @ Cloudflare",
  },
  {
    quote: "Omer is reliable, professional, knowledgeable, and consistently willing to help.",
    attribution: "Senior Manager, Customer Success @ Cloudflare",
  },
  {
    quote: "Omer's insights add real value in strategic customer conversations.",
    attribution: "Senior Manager, Customer Success @ Cloudflare",
  },
  {
    quote: "Omer explains complex situations with clarity and confidence.",
    attribution: "Senior Account Executive @ Cloudflare",
  },
  {
    quote: "Omer partners effectively with account teams to support important customers.",
    attribution: "Senior Account Executive @ Cloudflare",
  },
  {
    quote: "Omer helps customers understand what happened, what changed, and why they can move forward with confidence.",
    attribution: "Senior Account Executive @ Cloudflare",
  },
  {
    quote: "Omer brings quick turnaround, clarity, and reassurance when customers need help during a challenge.",
    attribution: "Customer Success Manager @ Cloudflare",
  },
  {
    quote: "Omer approaches difficult customer situations with honesty, transparency, specificity, and accountability.",
    attribution: "Customer Development Manager @ Cloudflare",
  },
  {
    quote: "Omer communicates clearly and does the right thing when trust matters most.",
    attribution: "Customer Development Manager @ Cloudflare",
  },
  {
    quote: "Omer helps turn difficult customer moments into stronger long-term partnerships.",
    attribution: "Customer Success Manager @ Cloudflare",
  },
  {
    quote: "Omer guides customers through facts, analysis, and practical recommendations.",
    attribution: "Territory Account Executive @ Cloudflare",
  },
  {
    quote: "Omer can step in quickly, analyze a customer setup, and offer practical ways to improve security.",
    attribution: "Senior Commercial Account Executive @ Cloudflare",
  },
  {
    quote: "Omer brings a gold-standard mix of accountability and empathy to customer work.",
    attribution: "Customer Success Manager @ Cloudflare",
  },
  {
    quote: "Omer puts real effort into making sure customers have the best possible product experience.",
    attribution: "Systems Engineer @ Cloudflare",
  },
  {
    quote: "Omer earns customer trust through credible, thoughtful, and practical engagement.",
    attribution: "Systems Engineer @ Cloudflare",
  },
  {
    quote: "Omer brings practical reassurance and an authoritative voice during customer escalations.",
    attribution: "Senior Engineering Director @ Cloudflare",
  },
  {
    quote: "Omer understands the product deeply and has strong instincts for how customers can benefit from it.",
    attribution: "Senior Engineering Director @ Cloudflare",
  },
  {
    quote: "Omer communicates clearly, works like a team player, and knows how to bring the right stakeholders together.",
    attribution: "Product Marketing Manager @ Cloudflare",
  },
  {
    quote: "Omer is someone teams can count on to get the right people involved and move work forward efficiently.",
    attribution: "Product Marketing Manager @ Cloudflare",
  },
  {
    quote: "Omer can assemble cross-functional teams and align them around a single purpose.",
    attribution: "Senior Technical Writer @ Cloudflare",
  },
  {
    quote: "Omer helps collaborators feel empowered, relevant, and connected to the bigger picture.",
    attribution: "Senior Technical Writer @ Cloudflare",
  },
  {
    quote: "Omer communicates effectively and on time across cross-functional teams.",
    attribution: "Principal Supportability Program Manager @ Cloudflare",
  },
  {
    quote: "Omer has strong technical depth and a deep understanding of cybersecurity.",
    attribution: "Principal Supportability Program Manager @ Cloudflare",
  },
  {
    quote: "Omer has a rare ability to make complex topics simple and useful.",
    attribution: "Product Marketing Manager @ Cloudflare",
  },
  {
    quote: "Omer handled a tough inherited customer situation with grace, clarity, and strong judgment.",
    attribution: "VP, Product Management @ Cloudflare",
  },
  {
    quote: "Omer can step into a high-risk customer escalation and help turn it into renewed confidence.",
    attribution: "Chief Product Officer @ Cloudflare",
  },
  {
    quote: "Omer's work helped protect an important customer relationship when the stakes were commercially meaningful.",
    attribution: "Chief Product Officer @ Cloudflare",
  },
  {
    quote: "Omer is recognized as a product leader who raises the quality and credibility of analyst-facing work.",
    attribution: "Director, Analytics Relations @ Cloudflare",
  },
  {
    quote: "Omer's contributions help public policy teams explain complex security topics with authority and regional relevance.",
    attribution: "Director, Public Policy, APAC & Oceania @ Cloudflare",
  },
  {
    quote: "Omer is viewed as a critical public-policy partner whose dedication and collaborative spirit strengthen the company's position.",
    attribution: "Director, Public Policy, APAC & Oceania @ Cloudflare",
  },
  {
    quote: "When teams need judgment on DDoS protection, they consistently route questions, approvals, and customer decisions to Omer.",
    attribution: "Cross-functional colleagues @ Cloudflare",
  },
  {
    quote: "Omer understands other perspectives and can articulate his own view with clarity.",
    attribution: "Senior Engineering Manager @ Cloudflare",
  },
  {
    quote: "Omer and the team prepared strong customer-facing content that showed thought leadership without feeling promotional.",
    attribution: "Principal Marketing Manager @ Cloudflare",
  },
  {
    quote: "Omer helps create new ways to engage customers at scale in formats that audiences respond to well.",
    attribution: "Customer Success Manager @ Cloudflare",
  },
  {
    quote: "Omer builds team morale through transparency, strong documentation, and clear strategic alignment.",
    attribution: "Lead Product Designer @ Cloudflare",
  },
  {
    quote: "Omer is a user-centric leader who supports onboarding, mentorship, and technical learning.",
    attribution: "Lead Product Designer @ Cloudflare",
  },
  {
    quote: "Omer models how to respond to unhappy customers with empathy, clarity, and professionalism.",
    attribution: "Lead Product Designer @ Cloudflare",
  },
  {
    quote: "Omer's product practices are viewed as world-class by teammates working close to the details.",
    attribution: "Lead Product Designer @ Cloudflare",
  },
  {
    quote: "Omer stays efficient, organized, and helpful even during busy periods.",
    attribution: "Senior Technical Writer @ Cloudflare",
  },
  {
    quote: "Omer makes time for teammates, answers questions, and helps people move faster.",
    attribution: "Senior Technical Writer @ Cloudflare",
  },
  {
    quote: "Omer communicates well, jumps in to help, and brings patience and kindness to collaboration.",
    attribution: "Product Marketing Manager @ Cloudflare",
  },
  {
    quote: "Omer is an excellent collaborator and co-host who helps make technical events stronger.",
    attribution: "Product Marketing Manager @ Cloudflare",
  },
  {
    quote: "Omer is generous with mentorship and welcomes ideas from teammates working around the product.",
    attribution: "Systems Engineer @ Cloudflare",
  },
  {
    quote: "Omer is empathetic and outcome-driven, helping teams do their best work in a sustainable way.",
    attribution: "Engineering Manager @ Cloudflare",
  },
  {
    quote: "Omer partners well with engineers to balance design, feasibility, and user experience.",
    attribution: "Engineering Manager @ Cloudflare",
  },
  {
    quote: "Omer is an excellent speaker and storyteller who represents the company with credibility.",
    attribution: "Product Marketing Manager @ Cloudflare",
  },
  {
    quote: "Omer's expertise helps reach senior audiences with credible, high-value technical insight.",
    attribution: "Product Marketing Manager @ Cloudflare",
  },
  {
    quote: "There’s only two certainties in life: Death, and the Finnish crowds coming out for Omer’s sessions.",
    attribution: "Senior Marketing Events Manager @ Cloudflare",
  },
  {
    quote: "Omer's writing is clear, articulate, and well received by customers.",
    attribution: "Senior Customer Success Manager @ Cloudflare",
  },
  {
    quote: "Omer's time and expertise help position Cloudflare as a credible global cybersecurity leader.",
    attribution: "Director, Public Policy @ Cloudflare",
  },
  {
    quote: "Omer goes beyond core product work by sharing insight through webinars, writing, and external education.",
    attribution: "Senior Engineering Manager @ Cloudflare",
  },
  {
    quote: "Omer invests time in product deep-dives that help designers understand complex security capabilities.",
    attribution: "Product Designer @ Cloudflare",
  },
  {
    quote: "Omer helps teammates connect the dots across complex product areas and understand how the work fits together.",
    attribution: "Product Designer @ Cloudflare",
  },
];
